import React from 'react';

export const FormSection = ({
	title,
	actionButton,
	children,
	required = false,
	className = '',
	size = 1
}) => {
	return (
		<div className={`form-section ${className}`} style={{ flex: size }}>
			<div className="form-section-header">
				{title && (
					<h3 className="form-section-title">
						{title} {required && <span style={{ color: '#dc3545' }}>*</span>}
					</h3>
				)}
				{actionButton && (
					<div className="form-section-action-button">{actionButton}</div>
				)}
			</div>
			{children}
		</div>
	);
};
